import { lazy } from 'react';
const NuestrasClinicasPage = lazy(() => import('../../pages/NuestrasClinicasPage'));
const SwissMedicalCenterPage = lazy(() => import('../../pages/SwissMedicalCenterPage'));
const VacunatorioPage = lazy(() => import('../../pages/Vacunatorio'));

const medicalCenterRoutes = [
  {
    title: 'Swiss Medical Center',
    path: 'centrosmedicos/swiss-medical-center',
    component: SwissMedicalCenterPage,
    isPrivate: false,
  },
  {
    title: 'Swiss Medical Center',
    path: 'centrosmedicos/centros-odontologicos',
    component: SwissMedicalCenterPage,
    isPrivate: false,
  },
  {
    title: 'Nuestras Clínicas',
    path: 'centrosmedicos/nuestras-clinicas',
    component: NuestrasClinicasPage,
    isPrivate: false,
  },
  {
    title: 'Vacunatorios',
    path: 'centrosmedicos/vacunatorios',
    component: VacunatorioPage,
    isPrivate: false,
  },
];

export default medicalCenterRoutes;
